import { Entry } from '../Entry'

export function Entry20220608() {
  return (
    <Entry title="08/06/2022 - v3.0.11">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12619/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
